import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AppRoutes } from '../../app.routes';

export const LoginGuardCanActivate: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.isAuthorized()
        ? router.createUrlTree([AppRoutes.Auctions])
        : true;
};
